module.exports = __webpack_public_path__ + "static/media/cp2lte.6cf1754d.png";